import React, { useState } from "react";
import { getFullAwsUrl } from "../../../../helpers/utils";
import CommonFilePreviewModal from "../../../Components/CommonFilePreviewModal";

const DesignsDetails = ({ data }: { data: any }) => {
  const [previewFiles, setPreviewFiles] = useState<any>(null);
  const [previewIndex, setPreviewIndex] = useState<number>(0);
  const [previewModalOpen, setPreviewModalOpen] = useState<boolean>(false);
  if (!data) return null;

  const designList = data.designs || [];

  

  // --- Helper to clean up S3 file names ---
  const getCleanFileName = (url: string) => {
    try {
      if (!url) return "Unknown File";
      const parts = url.split("/");
      const fullName = parts[parts.length - 1];
      // Check for UUID pattern (approx 36 chars + underscore)
      if (fullName.includes("_") && fullName.length > 37) {
        return fullName.substring(fullName.indexOf("_") + 1);
      }
      return fullName;
    } catch (e) {
      return "File";
    }
  };

  return (
    <div>
      {/* Header */}
      <h4 className="fs-5 fw-bold text-black mb-md-3 mb-2">Designs</h4>

      {/* Main Card */}
      <div className="card border-0 shadow-sm p-md-4 p-3 rounded-4 bg-white">
        <div className="d-flex align-items-center gap-5 mb-3 border-bottom pb-2">
          <div>
            <label className="fs-6 fw-normal text-949494">
              Drawing Number:
            </label>{" "}
            <span className="fw-semibold text-primary fs-6">
              {data.design_drawing_number || "-"}
            </span>
          </div>
          <div>
            <label className="fs-6 fw-normal text-949494">Revision:</label>{" "}
            <span className="fw-semibold text-primary fs-6">
              {data.design_revision || "-"}
            </span>
          </div>
        </div>
        {designList.length > 0 ? (
          <div className="d-flex flex-column gap-2">
            {designList.map((design: any, index: number) => (
              <div
                key={design._id || index}
                className="card border rounded-3 shadow-none"
              >
                <div className="card-body py-sm-3 py-2 px-sm-4 px-3 d-flex align-items-center justify-content-between gap-2">
                  {/* File Name */}
                  <span className="fs-6 fw-medium text-dark text-break">
                    {getCleanFileName(design.file_url)}
                  </span>

                  {/* View Action */}
                  <span
                    className="fs-6 fw-bold text-dark text-decoration-underline cursor-pointer"
                    onClick={() => {
                      const urls = designList.map((d: any) => d.file_url);
                      setPreviewFiles(urls);
                      setPreviewIndex(index);
                      setPreviewModalOpen(true);
                    }}
                  >
                    View
                  </span>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="text-center text-muted py-3 fst-italic">
            No designs uploaded.
          </div>
        )}
      </div>

      <CommonFilePreviewModal
        visible={previewModalOpen}
        onClose={() => {
          setPreviewModalOpen(false);
          setPreviewFiles([]);
          setPreviewIndex(0);
        }}
        files={previewFiles}
        activeIndex={previewIndex}
        onActiveIndexChange={setPreviewIndex}
      />
    </div>
  );
};

export default DesignsDetails;
